/* unplugin-vue-components disabled */import script from "./heroSubPage.vue?vue&type=script&lang=js"
export * from "./heroSubPage.vue?vue&type=script&lang=js"

import "./heroSubPage.vue?vue&type=style&index=0&id=59efdea2&lang=scss"

const __exports__ = script;

export default __exports__